// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"ea2cf0a1","562":"f90844c1"}[chunkId] + ".css";
};